import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getTipoFormacao, cadastrarTipoFormacao, alterarTipoFormacao, excluirTipoFormacao } from './tipos_formacoes_service';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
export var TiposFormacoesAlterar = function () {
    var services = {
        getItem: getTipoFormacao,
        cadastrarItem: cadastrarTipoFormacao,
        alterarItem: alterarTipoFormacao,
        excluirItem: excluirTipoFormacao,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.TIPOS_FORMACOES, paginaPermissao: FUNCIONALIDADES.TIPOS_FORMACOES, rota: ROUTES.TIPOS_FORMACOES, services: services });
};
export default TiposFormacoesAlterar;
